import { CloseOutlined, MinusOutlined, PlusOutlined } from "@ant-design/icons";
import { Button, InputNumber, message, Switch } from "antd";
import axios from "axios";
import { create } from "zustand";
import css from "./Income.module.css";

const fmtSum = (v) => Number(v || 0).toLocaleString("ru-RU").replace(/,/g, " ");

export const useComing = create((set, get) => ({
    coming: [],
    render: false,
    setRender: (v) => {
        set({ render: v })
    },
    ed: {},
    sitems: [],
    selected: [],
    setSelected: (s) => {

        let sfind = get().selected.find((item) => item.id === s.id)
        if (sfind?.id) {
            let other = get().selected.filter((item) => item.id !== s.id)
            sfind.count = ++sfind.count
            sfind.summa = sfind.count * sfind.price
            set({ selected: [...other, sfind] })
        } else {
            s = {
                id: s.id,
                p_id: s.id,
                code: s.sku,
                nameuz: s.product,
                count: 1,
                price: s.in_usd,
                sheriklik: false,
                summa: s.in_usd * s.count
            }
            set({ selected: [...get().selected, s] })
        }
    },
    searchItem: (param) => {
        if (param.length >= 1) {
            axios.get(`/product/${param}`).then(res => {
                set({ sitems: res.data })
            })
        }
    },
    reCount: (count, id) => {
        let sfind = get().selected.find((item) => item.id === id)
        let other = get().selected.filter((item) => item.id !== id)
        sfind.count = count
        sfind.summa = sfind.count * sfind.price
        set({ selected: [...other, sfind].sort((a, b) => a.id - b.id) })
    },
    rePrice: (price, id) => {
        let sfind = get().selected.find((item) => item.id === id)
        let other = get().selected.filter((item) => item.id !== id)
        sfind.price = price
        sfind.summa = sfind.count * sfind.price
        set({ selected: [...other, sfind].sort((a, b) => a.id - b.id) })
    },
    reSheriklik: (sheriklik, id) => {
        let sfind = get().selected.find((item) => item.id === id)
        let other = get().selected.filter((item) => item.id !== id)
        sfind.sheriklik = sheriklik
        set({ selected: [...other, sfind].sort((a, b) => a.id - b.id) })
    },
    handleRemoveProduct: (id) => {
        let other = get().selected.filter((item) => item.id !== id)
        set({ selected: other })
    },
    scolumns: [
        {
            title: 'Mahsulot',
            dataIndex: 'nameuz',
            key: 'nameuz',
            render: (_, rec) => <div className={css.cellCode}>
                <b>{rec.nameuz}</b>
                <span>{rec.code}</span>
            </div>
        },
        {
            title: 'Soni',
            dataIndex: 'count',
            key: 'count',
            width: 130,
            align: 'center',
            render: (_, rec) => <div className={css.qtyControl}>
                <Button type='text' size="small" onClick={() => { get().reCount(rec.count - 1, rec.id) }} icon={<MinusOutlined />} />
                <input type="number" value={rec.count} onChange={(e) => get().reCount(Number(e.target.value), rec.id)} />
                <Button type='text' size="small" onClick={() => { get().reCount(rec.count + 1, rec.id) }} icon={<PlusOutlined />} />
            </div>
        },
        {
            title: 'Narxi',
            dataIndex: 'price',
            key: 'price',
            width: 140,
            align: 'right',
            render: (_, rec) => <InputNumber
                className={css.priceInput}
                controls={false}
                min={0}
                value={rec.price}
                formatter={(v) => `${v}`.replace(/\B(?=(\d{3})+(?!\d))/g, ' ')}
                parser={(v) => `${v}`.replace(/\s/g, '')}
                onChange={(v) => { get().rePrice(v ?? 0, rec.id) }}
            />
        },
        {
            title: 'Summa',
            dataIndex: 'subTotal',
            key: 'subTotal',
            width: 130,
            align: 'right',
            render: (_, rec) => <div className={css.cellSub}>{fmtSum(rec.count * rec.price)}</div>
        },
        {
            title: 'Sheriklik',
            dataIndex: 'sheriklik',
            key: 'sheriklik',
            width: 90,
            align: 'center',
            render: (_, rec) => <Switch defaultChecked={rec.sheriklik} onChange={(e) => { get().reSheriklik(e, rec.id) }} />
        },
        {
            title: '',
            dataIndex: 'action',
            key: 'action',
            width: 48,
            align: 'center',
            render: (_, record) => {
                return <Button type='text' danger icon={<CloseOutlined />} onClick={() => get().handleRemoveProduct(record.id)} />
            },
        }
    ],
    create: (data) => {
        axios.post('/comin', data).then(res => {
            message.success("Muvaffaqiyatli qo'shildi!")
            set({ selected: [] })
            get().setRender(!get().render)
        })
    },
    getComing: () => {
        axios.get('/comin').then(res => {
            set({ coming: res.data })
        })
    }
}))
